module.exports = __webpack_public_path__ + "media/images/area/icon_weather_21-01ad3c04b4b00801e65a1d89b6322f71.png";